//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'
import '@react/App.css'
import { BrowserRouter } from 'react-router-dom'

import BorrowerRouting from './BorrowerRouting'
import { ErrorBoundary } from '@react/components/ErrorBoundary'

import { LicenseInfo } from '@mui/x-license-pro'
import { SagaNavigationWrapper } from '@react/components/SagaNavigationWrapper'
import { useTheme } from '@mui/material'

LicenseInfo.setLicenseKey(
  '4aa820c74354bf0194df6f7dfa013a7fTz0xMTE4ODYsRT0xNzc3MDc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)

function BorrowerApp(): React.ReactElement {
  document.title = 'OpenTrade Borrower'
  const theme = useTheme()

  return (
    <div
      className="App"
      style={{
        height: '100%',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.canvas,
        overflow: 'scroll',
      }}
    >
      <title>OpenTrade Borrower</title>

      <BrowserRouter>
        <SagaNavigationWrapper>
          <ErrorBoundary>
            <BorrowerRouting />
          </ErrorBoundary>
        </SagaNavigationWrapper>
      </BrowserRouter>
    </div>
  )
}

export default BorrowerApp
